import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { KalenderAbwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByMitarbeiter/KalenderAbwesenheit';
import { PopoverContent } from '@e2n/ui';

export function MitarbeiterAbwesenheitIntervalContent({
  interval,
  onMouseEnter,
  onMouseLeave,
}: {
  interval: KalenderAbwesenheit;
  onMouseEnter: (event: React.MouseEvent) => void;
  onMouseLeave: () => void;
}) {
  const abwesenheitslaengeInTagen =
    dayjs(interval.abwesenheit.bis)
      .startOf('day')
      .diff(dayjs(interval.abwesenheit.von).startOf('day'), 'day') + 1;

  return (
    <>
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className="w-full h-full bg-neutrals-300 border-neutrals-700 border border-solid rounded-md flex items-center justify-start px-2">
        {abwesenheitslaengeInTagen >= 2 && (
          <div className="text-xs truncate">
            <FontAwesomeIcon
              className="mr-0.5"
              icon={interval.abwesenheit.abwesenheitsgrundIcon}
            />
            {interval.abwesenheit.grund}
          </div>
        )}
        <PopoverContent className="bg-white flex gap-2 justify-between p-3 text-sm w-75">
          <div className="flex gap-2 items-center">
            <FontAwesomeIcon
              icon={interval.abwesenheit.abwesenheitsgrundIcon}
            />
            <div>{interval.abwesenheit.grund}</div>
          </div>
          <div className="font-semibold">
            {interval.abwesenheit.zeitraumLabel}
          </div>
        </PopoverContent>
      </div>
    </>
  );
}
